/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * The theme to be updated.
 */
export enum UserSettingsUiTheme {
    SYSTEM = 'System',
    DARK = 'Dark',
    LIGHT = 'Light',
}
